import moment from 'moment';

const timeStamp = {
    sec: 1e3,
    min: 60e3,
    hr: 3.6e6,
    day: 8.64e7,
    month: 2.628e9,
    year: 3.154e10,
};
const shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const fullMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const getShortDate = (date, separator = ' ', monthFormat = 'MMM') => {
    let month;
    const newDate = new Date(date);
    const day = newDate.getDate();
    const year = newDate.getFullYear();
    switch (monthFormat) {
        case 'MMM':
            month = newDate.toLocaleString('en-us', { month: 'short' });
            break;
        case 'M':
            month = newDate.getMonth() + 1;
            break;
        default:
            month = newDate.toLocaleString('en-us', { month: 'short' });
    }
    return `${day}${separator}${month}${separator}${year}`;
};

export const ensureTimezoneInDateString = (dateString) => {
    dateString = dateString.trim().toUpperCase();
    if (!/[+-][0-9]{1,2}(:[0-9]{2}(\.[0-9]+)?)?$|Z$/.test(dateString)) {
        dateString += 'Z';
    }
    return dateString;
};

export const getTimeOfPost = (dateOfPost) => {
    dateOfPost = ensureTimezoneInDateString(dateOfPost);

    const currentDateTime = new Date();
    const timeDiff = currentDateTime - new Date(dateOfPost);

    let timeOfPost = '';
    switch (true) {
        case timeDiff > timeStamp.min && timeDiff < timeStamp.hr:
            timeOfPost =
                Math.floor(timeDiff / timeStamp.min) > 1
                    ? `${Math.floor(timeDiff / timeStamp.min)} minutes ago`
                    : `${Math.floor(timeDiff / timeStamp.min)} minute ago`;
            break;
        case timeDiff > timeStamp.hr && timeDiff < timeStamp.day:
            timeOfPost =
                Math.floor(timeDiff / timeStamp.hr) > 1
                    ? `${Math.floor(timeDiff / timeStamp.hr)} hours ago`
                    : `${Math.floor(timeDiff / timeStamp.hr)} hour ago`;
            break;
        case timeDiff > timeStamp.day && timeDiff < timeStamp.month:
            timeOfPost =
                Math.floor(timeDiff / timeStamp.day) > 1
                    ? `${Math.floor(timeDiff / timeStamp.day)} days ago`
                    : `${Math.floor(timeDiff / timeStamp.day)} day ago`;
            break;
        case timeDiff > timeStamp.month && timeDiff < timeStamp.year:
            timeOfPost =
                Math.floor(timeDiff / timeStamp.month) > 1
                    ? `${Math.floor(timeDiff / timeStamp.month)} months ago`
                    : `${Math.floor(timeDiff / timeStamp.month)} month ago`;
            break;
        case timeDiff > timeStamp.year:
            timeOfPost =
                Math.floor(timeDiff / timeStamp.year) > 1
                    ? `${Math.floor(timeDiff / timeStamp.year)} years ago`
                    : `${Math.floor(timeDiff / timeStamp.year)} year ago`;
            break;
        default:
            timeOfPost = 'Just Now';
    }

    return timeOfPost;
};

export const getDayName = (sdt) => {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][moment.utc(sdt).get('day')];
};

export const getDayOfMonth = (sdt) => {
    return moment.utc(sdt).date();
};

export const getMonthYearTime = (sdt, edt) => {
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'][
        moment.utc(sdt).get('month')
    ];
    const year = moment.utc(sdt).get('year');
    let h = `0${moment.utc(sdt).get('hour')}`;
    let m = `0${moment.utc(sdt).get('minute')}`;
    const stime = `${h.slice(-2)}:${m.slice(-2)}`;
    h = `0${moment.utc(edt).get('hour')}`;
    m = `0${moment.utc(edt).get('minute')}`;
    const etime = `${h.slice(-2)}:${m.slice(-2)}`;
    return `${monthName} ${year} ${stime}-${etime}`;
};

export const getDateMonthYearTimeStamp = (date) => {
    const day = moment.utc(date).get('day');
    const month = shortMonthNames[moment.utc(date).get('month')];
    const year = moment.utc(date).get('year');

    return `${day || ''} ${month || ''} ${year || ''}`;
};

export const getMonthYear = (date) => {
    if (date != null) {
        const nDate = new Date(date);
        const month = shortMonthNames[nDate.getMonth()];
        const year = nDate.getFullYear();
        return `${month} ${year}`;
    }
    return null;
};

export const getMonthName = (date) => {
    if (date != null) {
        const nDate = new Date(date);
        const month = fullMonthNames[nDate.getMonth()];
        return `${month}`;
    }
    return null;
};

export const makeYearMonthDate = (data) => {
    const array = [];

    if (!(data && data.length > 0)) return null;

    data.sort((a, b) => {
        return new Date(a.startDateTime) - new Date(b.startDateTime);
    });
    data = data.filter(event => !event.isDeclined);

    array.push({ year: new Date(data[0].startDateTime).getFullYear(), months: [] });

    data.forEach((event) => {
        const year = new Date(event.startDateTime).getFullYear();
        const arrayLastIdx = array.length - 1;
        if (year > array[arrayLastIdx].year) {
            array.push({ year, months: [] });
        }
    });

    array.forEach((arrayItem) => {
        const foundEvents = data.filter(event => arrayItem.year === new Date(event.startDateTime).getFullYear());
        foundEvents.forEach((event) => {
            const monthObj = {
                id: new Date(event.startDateTime).getMonth(),
                monthName: getMonthName(event.startDateTime),
            };
            const isMonthExist = arrayItem.months.some(item => item.id === monthObj.id);
            if (!isMonthExist) {
                arrayItem.months.push(monthObj);
            }
        });
    });
    return array;
};

export const getShortMonthName = (month) => {
    return shortMonthNames[month];
};

export const getFullMonthNames = () => {
    return fullMonthNames;
};

export const getListOfYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= 1900; y -= 1) {
        years.push(y);
    }
    return years;
};
export const getMonthYearTimeForEvents = (sdt) => {
    const monthName = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'][
        new Date(sdt).getUTCMonth()
    ];
    const year = moment.utc(sdt).get('year');
    const h = `0${moment.utc(sdt).get('hour')}`;
    const m = `0${moment.utc(sdt).get('minute')}`;
    const stime = `${h.slice(-2)}:${m.slice(-2)}`;
    return `${monthName} ${year} ${stime}`;
};

export const getMonthDateTimeForNotifications = (sdt) => {
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'][
        new Date(sdt).getMonth()
    ];
    const date = new Date(sdt).getDate();
    const h = `0${new Date(sdt).getHours()}`;
    const m = `0${new Date(sdt).getMinutes()}`;
    const stime = `${h.slice(-2)}:${m.slice(-2)}`;
    return `${monthName} ${date} ${stime}`;
};
export const getEventDates = (startDateTime, endDateTime, yearToShow) => {
    let startDate = {};
    let endDate = {};

    if (startDateTime) {
        startDate = {
            date: moment.utc(startDateTime).date() || '',
            month: getShortMonthName(moment.utc(startDateTime).month()) || '',
            year: yearToShow || moment.utc(startDateTime).year() || '',
        };
    }
    if (endDateTime) {
        endDate = {
            date: moment.utc(endDateTime).date() || '',
            month: getShortMonthName(moment.utc(endDateTime).month()) || '',
            year: yearToShow || moment.utc(endDateTime).year() || '',
        };
    }

    const eventStartDate =
        startDate.date === endDate.date && startDate.month === endDate.month && startDate.year === endDate.year
            ? ''
            : startDate.date;
    const eventStartMonth = startDate.month === endDate.month && startDate.year === endDate.year ? '' : startDate.month;
    const eventStartYear = startDate.year === endDate.year ? '' : startDate.year;
    let eventStart = `${eventStartDate} ${eventStartMonth} ${eventStartYear}`;

    const eventEnd = `${endDate.date} ${endDate.month} ${endDate.year}`;
    const separator = `${
        startDate.date !== endDate.date || startDate.month !== endDate.month || startDate.year !== endDate.year
            ? '-'
            : ''
    }`;

    let result = `${eventStart} ${separator} ${eventEnd}`;

    if (startDate.month === endDate.month && startDate.year === endDate.year) {
        eventStart = eventStart.trim();
        const startString = `${eventStart}${separator}`.trim();
        result = `${startString}${eventEnd}`;
    }
    return result;
};

export const getYearOfEvent = (startDateTime, endDateTime) => {
    const startYear = moment.utc(startDateTime).year() || '';
    const endYear = moment.utc(endDateTime).year() || '';
    const separator = startYear && startYear !== endYear ? '-' : '';

    return `${startYear} ${separator} ${startYear !== endYear ? endYear : ''}`;
};

export const getEventDays = (startDateTime, endDateTime) => {
    const eventStartDate = moment.utc(startDateTime);
    const eventEndDate = moment.utc(endDateTime);
    const ms = eventEndDate.diff(eventStartDate, 'days');

    const startDay = getDayName(startDateTime) || '';
    const endDay = getDayName(endDateTime) || '';

    return ms ? `${startDay} - ${endDay}` : `${startDay}`;
};

export const getEventTime = (eventDate) => {
    const hTime = moment.utc(eventDate).hour();
    const mTime = moment.utc(eventDate).minutes();

    const actualHour = hTime > 9 ? hTime : `0${hTime}`;
    const actuamMinute = mTime > 9 ? mTime : `0${mTime}`;

    return `${actualHour}:${actuamMinute}`;
};

export const getFormattedDate = (date) => {
    let newDate = new Date();
    if (date != null) {
        newDate = new Date(date);
    }
    const month = newDate.getMonth() + 1;
    const day = newDate.getDate();
    const year = newDate
        .getFullYear()
        .toString()
        .substring(2, 4);
    return `${month}/${day}/${year}`;
};

//date format for Waiver DD/MM/YYYY
export const getFormattedDateUTC = (date) => {    
    return moment.utc(date).format('DD/MM/YYYY');
};
export const getCurrentYear = () => {
    const newDate = new Date();
    return newDate.getFullYear();
};

export const getYearFromUtc = (date) => {
    return moment.utc(date).get('year');
};

export const getMonthFromUtc = (date) => {
    return moment.utc(date).month();
};

export const getMonthYearFromUtc = (date) => {
    let result = '';
    if (date) {
        const year = getYearFromUtc(date);
        const month = getShortMonthName(getMonthFromUtc(date)) || '';
        result = `${month} ${year}`;
    }
    return result;
};

export const getFormattedDateForEmail = (date) => {
    const dt = new Date(date);
    return moment(dt).format('YYYY-MM-DD');
};
export const getFormattedHours = (date) => {
    const dt = new Date(date);
    let hour = moment(dt).get('hour');
    if (hour <= 9 && hour !== 0) {
        hour = `0${hour}`;
    }
    if (hour === 0) {
        hour = '00';
    }
    return hour;
};

export const getFormattedMinutes = (date) => {
    const dt = new Date(date);
    let minute = moment(dt).get('minute');
    if (minute <= 9 && minute !== 0) {
        minute = `0${minute}`;
    }
    if (minute === 0) {
        minute = '00';
    }
    return minute;
};

export const getMonthYearForEvents = (sdt) => {
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'][
        new Date(sdt).getMonth()
    ];
    const year = moment.utc(sdt).get('year');
    const h = `0${moment.utc(sdt).get('hour')}`;
    const m = `0${moment.utc(sdt).get('minute')}`;
    const stime = `${h.slice(-2)}:${m.slice(-2)}`;
    return `${monthName} ${year}`;
};

export const getFormattedDateWithDayMonthYearName = (sdt) => {
    return moment.utc(sdt).format('dddd, MMMM D, YYYY');
};

export const getFormattedDateMonthYear = (sdt) => {
    return moment.utc(sdt).format('D MMMM, YYYY');
};

//Calculating Age with Magic Year
export const calculateAge = (dateString) => {
    const birthday = +new Date(dateString);
    return ~~((Date.now() - birthday) / (31557600000));
};

export const addDays = (date, days) => {
    let newDate = new Date(date);
    if (days) {
        newDate = new Date(Number(date));
        newDate.setDate(newDate.getDate() + days);
    }
    return newDate;
};

export const addMinuteToDate = (date, minutes) => {
    const newDate = date ? new Date(date) : new Date();
    newDate.setMinutes(newDate.getMinutes() + (minutes || 0));
    return newDate;
};

export const formatWeekdayRange = (startDate, endDate) => {
    const shortWeekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const startDay = new Date(startDate).getDay();
    const endDay = new Date(endDate).getDay();
  
    if (startDate === endDate) {
      return shortWeekdays[startDay];
    }
  
    return `${shortWeekdays[startDay]} - ${shortWeekdays[endDay]}`;
  };

export const formatDate = (date) => {
  const options = { year: "2-digit", month: "2-digit", day: "2-digit" };
  return new Date(date).toLocaleDateString(undefined, options);
};
  
export const getOrdinalSuffix = (day) => {
    const j = day % 10;
    const k = day % 100;
    if (j === 1 && k !== 11) {
      return day + "st";
    } else if (j === 2 && k !== 12) {
      return day + "nd";
    } else if (j === 3 && k !== 13) {
      return day + "rd";
    } else {
      return day + "th";
    }
};

export const formatFullDate = (date) => {
    if (!date || isNaN(Date.parse(date))) {
      return 'Invalid Date';
    }
    const dateObj = new Date(date);
    const day = dateObj.getUTCDate();
    const month = dateObj.toLocaleString('default', { month: 'long', timeZone: 'UTC' }); 
    const year = dateObj.getUTCFullYear();
  
    const dayWithSuffix = getOrdinalSuffix(day);
  
    return `${month} ${dayWithSuffix} ${year}`;
};
export const formatDateRange = (startDate, endDate) => {
    const startFormatted = formatFullDate(startDate);
    const endFormatted = formatFullDate(endDate || startDate); 
    if (startFormatted === 'Invalid Date' || endFormatted === 'Invalid Date') {
      return 'Invalid Date Range';
    }
  
    return `${startFormatted} - ${endFormatted}`;
};

  
  

  
  
  
  